import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-try-it',
  templateUrl: './try-it.component.html',
  styleUrls: ['./try-it.component.css']
})
export class TryItComponent implements OnInit {

  public form: FormGroup;
  public submitted: boolean = false;
  public status: string;
  @Input()
  public service;

  public response: string = '';
  constructor(
    private http: Http,
    private formBuilder: FormBuilder) { }

  public ngOnInit() {
    let group: any = {};

    this.service.identifiers.forEach(identifier => {
      group[identifier.name] = new FormControl('', Validators.required);
    });
    const formGroup = new FormGroup(group);
    this.form = formGroup;
  }

  public onSubmit() {
    this.submitted = true;
    if (this.form.valid) {
      switch (this.service.urlMethod) {
        case 'GET':
          const baseUrl = environment.ssoMode ? window.location.origin : 'http://localhost:4000'
          let url = `${baseUrl}${this.service.urlPath}`;
          this.service.identifiers.map(item => {
            if (item.queryType === 'uri') {
              url = url.replace('{' + item.name + '}', this.form.controls[item.name].value);
            }
          });
          this.http.get(url).subscribe((response) => {
            this.status = response.status.toString();
            this.response = JSON.stringify(response.json(), null, 2);
          }, (error) => {
            this.status = error.status;
            this.response = JSON.stringify(error.json(), null, 2);
          });
          break;
        case 'POST':
          break;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/common/components/try-it/try-it.component.ts